import {assembleDymekContext} from './context.js';

function id(value){return String(value??'').trim()||null;}
function targetFor(bundle,stageId){
  return (bundle?.stageTargets||[]).find(row=>
    String(row?.stageId||row?.recipeStageId||'')===String(stageId||'')
  )||null;
}
function currentStage(bundle){
  const session=bundle?.session;
  if(!session)return null;
  const stage=(bundle?.stages||[]).find(row=>String(row.id)===String(session.activeStageId||''))||null;
  if(!stage)return null;
  const target=targetFor(bundle,stage.id);
  return Object.freeze({
    ...stage,
    startedAt:session.activeStageStartedAt||null,
    targetChamberCelsius:target?.targetChamberCelsius??null,
    minChamberCelsius:target?.minChamberCelsius??null,
    maxChamberCelsius:target?.maxChamberCelsius??null,
    plannedDurationMinutes:target?.plannedDurationMinutes??null
  });
}
function smokerData(bundle,refs){
  const smokerId=id(bundle?.session?.smokerId);
  if(!smokerId)return {smoker:null,capabilities:null};
  return {
    smoker:(refs?.smokers||[]).find(row=>String(row.id)===smokerId)||null,
    capabilities:(refs?.capabilities||[]).find(row=>String(row.smokerId||row.id)===smokerId)||null
  };
}

export function createDymekContextResolver({
  journalRuntime,
  recipeCache=null,
  userId=null
}={}){
  if(!journalRuntime?.sessionBundle||!journalRuntime?.completedHistoryBundles||!journalRuntime?.referenceData){
    throw new TypeError('Journal runtime is required');
  }
  const owner=id(userId||journalRuntime.userId);

  return async function resolveDymekContext({
    surfaceContext={surface:'home'},
    request={}
  }={}){
    const surface=String(surfaceContext?.surface||'home');
    let sessionId=id(surfaceContext?.sessionId);
    if(!sessionId&&surface==='active_session'){
      try{sessionId=id((await journalRuntime.sessions.active())?.id);}catch{}
    }

    const [currentBundle,historyBundles,refs]=await Promise.all([
      sessionId?journalRuntime.sessionBundle(sessionId):Promise.resolve(null),
      journalRuntime.completedHistoryBundles(),
      journalRuntime.referenceData({locale:'pl'})
    ]);

    let recipeRecord=null;
    const recipeId=id(surfaceContext?.recipeId);
    if(recipeId&&recipeCache?.get){
      try{recipeRecord=await recipeCache.get(recipeId,{userId:owner});}catch{}
    }
    const recipePlan=recipeRecord?.plan||null;
    const smoker=smokerData(currentBundle,refs);

    const currentRecipe=recipePlan?.recipe
      ||(currentBundle?.session?.recipeSourceSnapshot?{
        type:currentBundle.session.recipeSourceSnapshot.type,
        version:currentBundle.session.recipeVersion,
        sourceType:currentBundle.session.recipeSourceSnapshot.sourceName
      }:null);

    const context=assembleDymekContext({
      profile:null,
      smoker:smoker.smoker,
      smokerCapabilities:smoker.capabilities,
      availableWood:refs?.woodInventory||[],
      current:{
        session:currentBundle?.session||{},
        stage:currentStage(currentBundle),
        recipe:currentRecipe
      },
      temperatures:currentBundle?.temperatureReadings||[],
      events:currentBundle?.liveEvents||[],
      history:historyBundles.map(bundle=>({
        ...bundle.session,
        outcome:bundle.outcome
      })),
      request
    });

    return Object.freeze({
      surfaceContext:Object.freeze({
        surface,
        sessionId,
        recipeId
      }),
      context,
      currentBundle,
      historyBundles,
      recipePlan,
      recipe:recipePlan?.recipe||null,
      plannerSnapshot:currentBundle?.session?.plannerScheduleSnapshot||null,
      references:refs
    });
  };
}
